import script from "./Archive.vue?vue&type=script&setup=true&lang=js"
export * from "./Archive.vue?vue&type=script&setup=true&lang=js"

import "./Archive.vue?vue&type=style&index=0&id=afa40cca&lang=scss"

const __exports__ = script;

export default __exports__